import { render, staticRenderFns } from "./PreciosOdooView.vue?vue&type=template&id=b262c034"
import script from "./PreciosOdooView.vue?vue&type=script&lang=js"
export * from "./PreciosOdooView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports